import { useCallback, useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import '../../styles/dashboard-theme.css';
import { DASH_SIDEBAR_KEY } from '../../utils/storageKeys';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

function readSidebarExpanded() {
  try {
    return localStorage.getItem(DASH_SIDEBAR_KEY) !== 'collapsed';
  } catch {
    return true;
  }
}

export default function DashboardLayout() {
  const { pathname } = useLocation();
  const [sidebarExpanded, setSidebarExpanded] = useState(readSidebarExpanded);

  const toggleSidebar = useCallback(() => {
    setSidebarExpanded((open) => !open);
  }, []);

  useEffect(() => {
    try {
      localStorage.setItem(
        DASH_SIDEBAR_KEY,
        sidebarExpanded ? 'open' : 'collapsed'
      );
    } catch {
      /* ignore */
    }
  }, [sidebarExpanded]);

  return (
    <div
      className="dashboard-shell flex min-h-screen flex-col lg:flex-row"
      dir="ltr"
      lang="en"
    >
      <Sidebar expanded={sidebarExpanded} onToggle={toggleSidebar} />
      <div className="flex min-h-screen min-w-0 flex-1 flex-col">
        <Topbar pathname={pathname} onToggleSidebar={toggleSidebar} />
        <main className="dash-main flex-1 p-4 sm:p-6 lg:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
